import emptyImage from '@core/assets/images/empty_file.svg'
import fileImage from '@core/assets/images/file.svg'
import fileJpg from '@core/assets/images/fileJpg.svg'
import filePdf from '@core/assets/images/filePdf.svg'
import filePng from '@core/assets/images/filePng.svg'

function getAttachmentIcon(type: string) {
    switch (type) {
        case 'png':
            return filePng
        case 'jpg':
            return fileJpg
        case 'jpeg':
            return fileJpg
        case 'pdf':
            return filePdf
        default:
            return fileImage
    }
}

export default getAttachmentIcon
